import { MembersParams } from "@/models/payload/customerGroup";
import customerGroupService from "@/services/customerGroup";
import { useInfiniteQuery } from "@tanstack/react-query";

type Props = {
  params: MembersParams;
};

function useGetCustomerGroupsMembers({ params }: Props) {
  return useInfiniteQuery({
    queryKey: [
      "customerGroupMembers",
      params?.Term,
      params?.customerGroupId,
      params?.Count,
    ],
    queryFn: ({ pageParam = 0 }) =>
      customerGroupService.getMembers({ ...params, Skip: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const morePagesExist = lastPage?.result?.length === params.Count; // Assuming 10 items per page
      if (!morePagesExist) return undefined;
      return allPages.length * (params?.Count || 10); // Next page's skip value
    },

    // queryKey: [
    //   "customerGroupMembers",
    //   params?.Term,
    //   params?.customerGroupId,
    //   params?.Count,
    // ],
    // queryFn: () => customerGroupService.getMembers(params),
    // getNextPageParam: (lastPage, allPages) => {
    //   const totalCount = lastPage?.count || 0;
    //   const itemsFetched = allPages.flatMap((page) => page.result).length;
    //   if (itemsFetched < totalCount) {
    //     // There are more items to fetch
    //     return itemsFetched;
    //   } else {
    //     // No more items to fetch
    //     return undefined;
    //   }
    // },
  });
}

export default useGetCustomerGroupsMembers;
